import React, { useRef } from 'react';
import { FILTERS } from '../../metadata/fields'

function StatFilter({ index, config, value, setter }) {
    const inputRef = useRef(null)
    
    const handleFocus = () => {
        inputRef.current.focus();
    };

    return (
        <button className="clanleaderboard_stat_button" onFocus={() => handleFocus()}>
            <div className="clanleaderboard_stat_button_label" title={config.label}>{config.label}</div> 
            { !config.hasOwnProperty('options') ? (
                <>
                <input className="clanleaderboard_stat_button_input"
                    type="tel"
                    pattern="[0-9*]"
                    value={value}
                    ref={inputRef}
                    onKeyPress={(e) => config.formatter(e)} 
                    onChange={(e) => setter(config.validator(e.target.value))}/>
                <img className="clanleaderboard_stat_button_svg" src={`${window.STATIC_URL}portal/css/scss/clans/img/pencil.svg`}/>
                </>)
                : null 
            }
        </button>
    )
}

export default StatFilter;
